var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 480,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF1F7",
    d: "M0 0h760v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E6EB",
    fillRule: "evenodd",
    d: "M348.9 320.57a30 30 0 0 0-42.7-2.1L131 479.82h360L348.9 320.57Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C3CB",
    fillRule: "evenodd",
    d: "M540.99 239.8a30 30 0 0 0-44.05-.35L271 479.82h488.51L540.99 239.8Z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCFD5",
    fillRule: "evenodd",
    d: "M186.5 188a45.5 45.5 0 1 0 0-91 45.5 45.5 0 0 0 0 91Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.317b5c2455b67f217fe8f9394402c37b.svg";
export { ForwardRef as ReactComponent };